"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDashboardsNavigationMetaQueryOptions = void 0;
const initialData = {};
const getDashboardsNavigationMetaQueryOptions = (httpClient) => {
    var _a;
    return ({
        queryKey: ['dashboards', 'metaList'],
        initialData,
        refetchOnWindowFocus: false,
        notifyOnChangeProps: ['data', 'isFetching', 'isFetched'],
        select: (data) => Array.isArray(data)
            ? data.reduce((acc, { id, name }) => {
                acc[id] = { meta: { name } };
                return acc;
            }, {})
            : data,
        queryFn: () => {
            return httpClient(`${window.CUSTOMIZATION_BE}/dashboards/metaList`);
        },
        enabled: !((_a = window.CUSTOM_ENV) === null || _a === void 0 ? void 0 : _a.navGraph)
    });
};
exports.getDashboardsNavigationMetaQueryOptions = getDashboardsNavigationMetaQueryOptions;
